import { api } from "@/lib/api-client";
import type { CommissionSettings, CommissionSettingsForm } from "./types";

export function toCommissionForm(settings: CommissionSettings): CommissionSettingsForm {
  return {
    commissionsOpen: settings.isOpen,
    headline: settings.headline ?? "",
    introText: settings.introText ?? "",
    processText: settings.processText ?? "",
    pricingText: settings.pricingText ?? "",
    turnaroundText: settings.turnaroundText ?? "",
    requirementsText: settings.requirementsText ?? "",
    contactCtaText: settings.contactCtaText ?? "",
    contactCtaUrl: settings.contactCtaUrl ?? "",
    vehicleLiveriesEnabled: settings.vehicleLiveriesEnabled,
    uniformDesignsEnabled: settings.uniformDesignsEnabled,
    customDesignsEnabled: settings.customDesignsEnabled,
  };
}

function toPayload(input: CommissionSettingsForm) {
  return {
    isOpen: input.commissionsOpen,
    headline: input.headline || null,
    introText: input.introText || null,
    processText: input.processText || null,
    pricingText: input.pricingText || null,
    turnaroundText: input.turnaroundText || null,
    requirementsText: input.requirementsText || null,
    contactCtaText: input.contactCtaText || null,
    contactCtaUrl: input.contactCtaUrl || null,
    vehicleLiveriesEnabled: input.vehicleLiveriesEnabled,
    uniformDesignsEnabled: input.uniformDesignsEnabled,
    customDesignsEnabled: input.customDesignsEnabled,
  };
}

export const commissionSettingsApi = {
  get: () => api.get<CommissionSettings>("/commission-settings"),
  update: (input: CommissionSettingsForm) => api.patch<CommissionSettings>("/commission-settings", toPayload(input)),
};
